// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/@material/radio/dist/mdc.radio.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/@material/form-field/dist/mdc.form-field.min.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mdc-form-field {
    width: 100%;
    font-family: 'Nunito Sans', Sans-serif, sans-serif;
    margin-bottom: 6px;
}

/* to remove the character count for the option question types */
.star-line .mdc-text-field-character-counter {
    display: none;
}
`, "",{"version":3,"sources":["webpack://./src/form/css/material-multiple-choice.css"],"names":[],"mappings":"AAGA;IACI,WAAW;IACX,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA,gEAAgE;AAChE;IACI,aAAa;AACjB","sourcesContent":["@import \"../../../node_modules/@material/radio/dist/mdc.radio.min.css\";\n@import \"../../../node_modules/@material/form-field/dist/mdc.form-field.min.css\";\n\n.mdc-form-field {\n    width: 100%;\n    font-family: 'Nunito Sans', Sans-serif, sans-serif;\n    margin-bottom: 6px;\n}\n\n/* to remove the character count for the option question types */\n.star-line .mdc-text-field-character-counter {\n    display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
